import { render } from "./DiscoverHome.vue?vue&type=template&id=44892647"
import script from "./DiscoverHome.vue?vue&type=script&lang=js"
export * from "./DiscoverHome.vue?vue&type=script&lang=js"

import "./DiscoverHome.vue?vue&type=style&index=0&id=44892647&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__